// src/js/components/donar-modal.js

document.addEventListener('DOMContentLoaded', () => {
  const modal       = document.getElementById('donar-modal');
  if (!modal) return;

  const modalContent    = modal.querySelector('.js-donar-modal-content');
  const formPanel       = document.getElementById('donar-modal-form-panel');
  const successPanel    = document.getElementById('donar-modal-success-panel');
  const errorPanel      = document.getElementById('donar-modal-error-panel');
  const errorMsg        = document.getElementById('donar-error-msg');
  const errorText       = document.getElementById('donar-send-error-text');
  const form            = document.getElementById('donar-form');
  const submitBtn       = document.getElementById('donar-submit-btn');
  const btnText         = document.getElementById('donar-btn-text');
  const btnIcon         = document.getElementById('donar-btn-icon');
  const btnSpinner      = document.getElementById('donar-btn-spinner');
  const retryBtn        = document.getElementById('donar-retry-btn');

  // Campos particular / empresa
  const particularFields = document.getElementById('don-particular-fields');
  const empresaFields    = document.getElementById('don-empresa-fields');

  // Opciones tipo donante
  const tipoParticular = document.getElementById('don-tipo-particular');
  const tipoEmpresa    = document.getElementById('don-tipo-empresa');

  // Wrap importe personalizado
  const importeCustomWrap = document.getElementById('don-importe-custom-wrap');
  const importeCustom     = document.getElementById('don-importe-custom');

  // ── Apertura / Cierre ──────────────────────────────────────────────

  const openModal = () => {
    [formPanel, errorMsg].forEach(el => el && el.classList.remove('hidden'));
    [successPanel, errorPanel].forEach(el => el && el.classList.add('hidden'));

    if (form) form.reset();
    switchTipo('particular');
    if (importeCustomWrap) importeCustomWrap.classList.add('hidden');

    modal.classList.remove('opacity-0', 'pointer-events-none');
    modalContent.classList.remove('scale-95');
    modalContent.classList.add('scale-100');
    document.body.style.overflow = 'hidden';
    modal.scrollTop = 0;
    if (errorMsg) errorMsg.classList.add('hidden');
  };

  const closeModal = () => {
    modal.classList.add('opacity-0', 'pointer-events-none');
    modalContent.classList.remove('scale-100');
    modalContent.classList.add('scale-95');
    document.body.style.overflow = '';
  };

  // ── Trigger botón ─────────────────────────────────────────────────

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-donar-modal-trigger');
    if (trigger) { e.preventDefault(); openModal(); }
  });

  // ── Cerrar modal ──────────────────────────────────────────────────

  modal.querySelectorAll('.js-donar-modal-close').forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  if (successPanel) {
    successPanel.addEventListener('click', (e) => {
      if (e.target.closest('.js-donar-modal-close')) closeModal();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('pointer-events-none')) closeModal();
  });

  // ── Switch Particular / Empresa ───────────────────────────────────

  function switchTipo(tipo) {
    if (tipo === 'empresa') {
      if (particularFields) particularFields.classList.add('hidden');
      if (empresaFields)    empresaFields.classList.remove('hidden');
    } else {
      if (particularFields) particularFields.classList.remove('hidden');
      if (empresaFields)    empresaFields.classList.add('hidden');
    }
  }

  [tipoParticular, tipoEmpresa].forEach(radio => {
    if (!radio) return;
    radio.addEventListener('change', () => {
      switchTipo(radio.value);
    });
  });

  // ── Importe personalizado ─────────────────────────────────────────

  if (form) {
    form.querySelectorAll('[name="importe_opcion"]').forEach(radio => {
      radio.addEventListener('change', () => {
        if (importeCustomWrap) {
          importeCustomWrap.classList.toggle('hidden', radio.value !== 'otro');
          if (radio.value !== 'otro' && importeCustom) importeCustom.value = '';
        }
      });
    });
  }

  // ── Retry ─────────────────────────────────────────────────────────

  if (retryBtn) {
    retryBtn.addEventListener('click', () => {
      if (errorPanel)  errorPanel.classList.add('hidden');
      if (formPanel)   formPanel.classList.remove('hidden');
      setLoading(false);
    });
  }

  // ── Helpers ───────────────────────────────────────────────────────

  function setLoading(loading) {
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    if (btnText)    btnText.textContent = loading ? 'Enviando...' : 'Enviar solicitud de donación';
    if (btnIcon)    btnIcon.classList.toggle('hidden', loading);
    if (btnSpinner) btnSpinner.classList.toggle('hidden', !loading);
  }

  function getTipoDonante() {
    return tipoEmpresa && tipoEmpresa.checked ? 'empresa' : 'particular';
  }

  function getImporte() {
    if (!form) return '';
    const checkedOpcion = form.querySelector('[name="importe_opcion"]:checked');
    if (!checkedOpcion) return '';
    if (checkedOpcion.value === 'otro') {
      return importeCustom ? importeCustom.value.trim() : '';
    }
    return checkedOpcion.value;
  }

  function collectData() {
    if (!form) return {};
    const fd   = new FormData(form);
    const data = {};

    for (const [key, value] of fd.entries()) {
      data[key] = value;
    }

    data.tipo_donante = getTipoDonante();
    data.importe      = getImporte();
    return data;
  }

  function validate() {
    let valid = true;
    const tipo = getTipoDonante();

    if (tipo === 'particular') {
      ['nombre', 'apellidos', 'email', 'fecha_nacimiento', 'dni',
       'telefono1', 'domicilio', 'numero', 'localidad', 'codigo_postal', 'provincia'].forEach(name => {
        const el = form.querySelector(`[name="${name}"]`);
        if (el && !el.value.trim()) valid = false;
      });
      const emailEl = form.querySelector('[name="email"]');
      if (emailEl && emailEl.value && !emailEl.value.includes('@')) valid = false;
    } else {
      ['empresa_nombre', 'empresa_contacto_nombre', 'empresa_contacto_apellidos',
       'empresa_email', 'empresa_telefono', 'empresa_cif', 'empresa_domicilio'].forEach(name => {
        const el = form.querySelector(`[name="${name}"]`);
        if (el && !el.value.trim()) valid = false;
      });
      const emailEl = form.querySelector('[name="empresa_email"]');
      if (emailEl && emailEl.value && !emailEl.value.includes('@')) valid = false;
    }

    // Objetivo obligatorio
    const objetivo = form.querySelector('[name="objetivo"]:checked');
    if (!objetivo) valid = false;

    // Importe obligatorio
    const importeOpc = form.querySelector('[name="importe_opcion"]:checked');
    if (!importeOpc) { valid = false; }
    else if (importeOpc.value === 'otro') {
      if (!importeCustom || !importeCustom.value.trim() || Number(importeCustom.value) < 1) valid = false;
    }

    return valid;
  }

  // ── Envío ─────────────────────────────────────────────────────────

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (errorMsg) errorMsg.classList.add('hidden');

      if (!validate()) {
        if (errorMsg) {
          errorMsg.classList.remove('hidden');
          errorMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      const data = collectData();

      // reCAPTCHA v3
      if (typeof grecaptcha !== 'undefined') {
        const siteKey = process.env.PARCEL_PUBLIC_RECAPTCHA_SITE_KEY || '6Ld_placeholder_site_key_fam';
        data.recaptchaToken = await grecaptcha.execute(siteKey, { action: 'donation' });
      }

      setLoading(true);

      try {
        const response = await fetch('/.netlify/functions/send-donar', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.message || `Error ${response.status}`);
        }

        setLoading(false);
        if (formPanel)    formPanel.classList.add('hidden');
        if (successPanel) successPanel.classList.remove('hidden');
        modal.scrollTop = 0;

      } catch (err) {
        console.error('Error al enviar formulario de donación:', err);
        setLoading(false);
        if (errorText)  errorText.textContent = err.message || 'Error inesperado. Por favor, inténtalo de nuevo.';
        if (formPanel)  formPanel.classList.add('hidden');
        if (errorPanel) errorPanel.classList.remove('hidden');
        modal.scrollTop = 0;
      }
    });
  }
});
